import React, { useEffect } from "react";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import MultiSelectField from "../../../MultiSelectField";
import { useProjectAssistMetadata } from "../../hooks/useProjectAssistMetadata";

export default function ProjectAssistMetadataSection({
  enabled,
  values,
  onChange,
  onLoadingChange,
  onError
}) {
  const {
    specializations,
    contentTypes,
    loading,
    error,
    refresh
  } = useProjectAssistMetadata(enabled);

  useEffect(() => {
    if (typeof onLoadingChange === "function") {
      onLoadingChange(loading);
    }
  }, [loading, onLoadingChange]);

  useEffect(() => {
    if (error && typeof onError === "function") {
      onError("Unable to load Project Assist metadata. Please try again later.");
    }
  }, [error, onError]);

  if (!enabled) {
    return null;
  }

  const handleChange = (field) => (selection) =>
    onChange(field, selection || []);

  return (
    <Box>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
        <Typography variant="subtitle1">Project Assist Metadata</Typography>
        <IconButton
          size="small"
          onClick={refresh}
          disabled={loading}
          aria-label="Refresh Project Assist metadata"
        >
          <RefreshIcon fontSize="small" />
        </IconButton>
      </Stack>

      <MultiSelectField
        label="Specializations"
        placeholder="Select specializations"
        value={values.projectAssistSpecializationIds}
        options={specializations}
        onChange={handleChange("projectAssistSpecializationIds")}
        noOptionsText="No specializations"
      />

      <MultiSelectField
        label="Content Types"
        placeholder="Select content types"
        value={values.projectAssistContentTypeIds}
        options={contentTypes}
        onChange={handleChange("projectAssistContentTypeIds")}
        noOptionsText="No content types"
      />
    </Box>
  );
}
